import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Image, StoreProjectFileInfo, ProjectFileNode, ImageCountInfo } from '../models/Image';
import { InstallationStoreData } from '../models/installationstoredata';
import { ProjectFilesVm } from '../../project-intake/models/project-vm';
import { ProjectFiles } from '../models/projectverification';
import { ProjectFileStoresInfo } from '../models/projectfilestoresinfo';

@Injectable({
  providedIn: 'root'
})
export class ImageService {

  constructor(private http: HttpClient) { }

  //Get ProjectFiles with Installation Store Id by Project Id
  GetStoresForImagesByProjectFiles(projectId: number): Observable<ProjectFileStoresInfo[]> {
    const url = `${environment.gateway_url}/getstoresforimagesbyprojectfiles/${projectId}`
    return this.http.get<ProjectFileStoresInfo[]>(url);
  }

  //Get Images by Project Id, Project FileId and Installation Store Id
  GetImages(projectId: number, installationStoreId: number, projectFileId: number): Observable<Image[]> {
    const url = `${environment.gateway_url}/getimages/${projectId}/${installationStoreId}/${projectFileId}`
    return this.http.get<Image[]>(url);
  }

  //Get Pending Images for validation by Project Id
  GetPendingImageCount(projectId: number): Observable<ProjectFileNode[]> {
    const url = `${environment.gateway_url}/getpendingimagecount/${projectId}`
    return this.http.get<ProjectFileNode[]>(url);
  }

  // //Get Images Count by Project Id
  // GetImagesCount(projectId: number): Observable<ImageCountInfo> {
  //   const url = `${environment.gateway_url}/getimagecountinfo/${projectId}`
  //   return this.http.get<ImageCountInfo>(url);
  // }

}